import { Box, Collapse, IconButton, Paper, Tooltip, Typography } from "@mui/material";
import { ReactNode, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface FormSectionProps {
  title: string;
  children: ReactNode;
  icon?: ReactNode;
  defaultExpanded?: boolean;
}

export const FormSection = ({
  title,
  children,
  icon,
  defaultExpanded = true,
}: FormSectionProps) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Paper
      elevation={2}
      sx={{
        borderRadius: "16px",
        overflow: "hidden",
        mb: 3,
      }}
    >
      <Box
        sx={{
          backgroundColor: "rgb(140, 150, 169)",
          px: 3,
          py: 1.5,
          display: "flex",
          alignItems: "center",
          gap: 1,
          cursor: "pointer",
          userSelect: "none",
          "&:hover": { backgroundColor: "rgb(120, 130, 149)" },
          transition: "background-color 0.2s ease",
        }}
        onClick={() => setExpanded((prev) => !prev)}
      >
        {icon && (
          <Box sx={{ color: "white", display: "flex", alignItems: "center" }}>
            {icon}
          </Box>
        )}
        <Typography variant="h6" sx={{ color: "white", fontWeight: 600, flexGrow: 1 }}>
          {title}
        </Typography>
        <Tooltip title={expanded ? "Collapse" : "Expand"} arrow>
          <IconButton
            size="small"
            aria-label={expanded ? "Collapse section" : "Expand section"}
            sx={{
              color: "white",
              transform: expanded ? "rotate(0deg)" : "rotate(-90deg)",
              transition: "transform 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
              "&:hover": { backgroundColor: "rgba(255,255,255,0.15)" },
            }}
          >
            <ExpandMoreIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <Collapse in={expanded} timeout={250}>
        <Box sx={{ p: { xs: 2, md: 3 } }}>{children}</Box>
      </Collapse>
    </Paper>
  );
};
